import ProviderSurgeIncentive from './components/provider-surge-incentive-container';

import './styles.scss';

export default ProviderSurgeIncentive;
